import React, { useEffect, useMemo } from 'react';
import { createHashHistory } from 'history';

import config from './config';
import { FeedContext } from './FeedContext';
import { generateHashString, toggleInArray } from './utils/helpers';
import { useData } from './utils/use-data';
import Filters, { useFilters } from './Filters';
import Results, { usePagination } from './Results';

function App({ perPage }) {
  const { loadData, dataState, posts, filters } = useData();
  const { selected, setSelected, query, setQuery, filterPosts } = useFilters();
  const { paged, setPaged, loadMore } = usePagination();

  // console.log(posts);

  useEffect(() => {
    loadData(config.jobsApiUrl);
  }, [config]);

  const context = useMemo(() => {
    const setFilter = (filter, id) => {
      setSelected((selected) => {
        const x = { ...selected };

        Object.keys(x).forEach((key) => {
          x[key] = [];
        });

        x[filter] = [id];

        return x;
      });
      setQuery('');
      setPaged(1);
    };

    const addFilter = (filter, id) => {
      setSelected({
        ...selected,
        [filter]: !selected[filter].includes(id)
          ? selected[filter].concat(id)
          : selected[filter],
      });
      setPaged(1);
    };

    const toggleFilter = (filter, id) => {
      setSelected({
        ...selected,
        [filter]: toggleInArray(selected[filter], id),
      });
      setPaged(1);
    };

    const clearFilter = (filter) => {
      setSelected({
        ...selected,
        [filter]: [],
      });
      setPaged(1);
    };

    return {
      addFilter,
      setFilter,
      toggleFilter,
      clearFilter,
      setQuery,
      loadMore,
    };
  }, [selected, setSelected, setPaged, setQuery]);

  const sortByDateDescending = (a, b) => {
    return b.timestamp - a.timestamp;
  };

  const paginatePosts = (posts) => {
    return posts.slice(0, perPage * paged);
  };

  useEffect(() => {
    const updateParams = () => {
      const history = createHashHistory();
      const str = generateHashString({
        countries: selected.countries.join(','),
      });

      window.location.hash = str;
      history.replace(`/${str}`);
    };

    updateParams();
  }, [selected]);

  const filteredPosts = filterPosts(posts);
  const sortedPosts = filteredPosts.sort(sortByDateDescending);
  const pagedPosts = paginatePosts(sortedPosts);

  return (
    <div className="l-jobs-feed__app">
      <FeedContext.Provider value={context}>
        <Filters
          filters={filters}
          selected={selected}
          query={query}
          loading={dataState !== 'loaded'}
        />
        <Results
          posts={pagedPosts}
          hasMorePosts={pagedPosts.length < filteredPosts.length}
          perPage={perPage}
          loading={dataState !== 'loaded'}
        />
      </FeedContext.Provider>
    </div>
  );
}

export default App;
